import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import swal from 'sweetalert2';
import { AddEditReportMailConfigComponent } from './addEditReportMailConfig.component';
import { ReportMailConfigService } from '../../../services/index';

@Component({
    selector: 'report-mail-config-tab',
    templateUrl: './reportMailConfig.component.html'
})
export class ReportMailConfigComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    listData: any[] = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'report_name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('activeTemplate') activeTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    bsModalRef: BsModalRef;

    constructor(private service: ReportMailConfigService, private modalService: BsModalService) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 60, minWidth: 60, maxWidth: 60, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Report Name', prop: 'report_name', width: 250, minWidth: 200 },
            { name: 'Mail ID', prop: 'mail_id', width: 300, minWidth: 200 },
            { name: 'Active', prop: 'is_active', width: 80, minWidth: 80, maxWidth: 80, cellClass: 'cell-center', cellTemplate: this.activeTemplate },
            { name: 'Action', prop: 'mail_config_id', width: 100, minWidth: 80, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getList();
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getList();
    }

    getList(): void {
        let that = this;
        const params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        this.isLoadMask = this.service.getList(params).then(function(res: any) {
            that.loadingIndicator = false;
            that.page.count = res.totCnt;
            that.listData = res.data;
        });
    }

    onAddEdit(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditReportMailConfigComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Mail Config';
        this.bsModalRef.content.rowdata = Object.assign({}, row);
        this.bsModalRef.content.saveEvent.subscribe(() => {
            that.getList();
        });
    }

    onDelete(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'Mail Config for ' + row.report_name + ' (' + row.mail_id + ') will be removed!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.service.delete(row.mail_config_id).then(function(res: any) {
                if (res.success) {
                    that.getList();
                    swal('Deleted', res.message, 'success');
                } else {
                    swal('ERROR', res.message, 'error');
                }
            });
        }, function() { });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/reportMailConfig/reportMailConfig.component.ts